import * as Sentry from '@sentry/browser'

export default function logError(e) {
    Sentry.captureException(e)
}

export function logConsole(...msgs) {
    if (process.env.CT_PUBLIC_DEBUG) console.log(...msgs)
}

export function groupCollapsedConsole(msg = 'Group Title', getGroupEnd = false) {
    if (process.env.CT_PUBLIC_DEBUG) {
        if (getGroupEnd) console.groupEnd()
        else console.groupCollapsed(msg)
    }
}

export const CT_SENTRY_ERROR_TYPES = {
    ERROR_BOUNDARY: 'Error Boundary',
    API_ERROR: 'API Error'
}

export function logSentryError(error, ctType, additionalData) {
    Sentry.withScope(function(scope) {
        scope.setTag('ct-error-type', ctType)

        const { tags, extras } = additionalData

        if (tags)
            Object.keys(tags).forEach(tag => {
                scope.setTag(tag, tags[tag])
            })

        if (extras)
            Object.keys(extras).forEach(extra => {
                scope.setExtra(extra, extras[extra])
            })

        // scope.setExtra('ct-error', error)
        // scope.setExtra('ct-error-info', errorInfo)
        scope.setLevel('error')
        // will be tagged with my-tag="my value"
        Sentry.captureException(error)
    })
}

export function setSentryError(error) {
    const errorObj = JSON.stringify(error)

    const { response: { status, statusText } = {}, config: { url = '', data = {} } = {} } = JSON.parse(errorObj) || {}
    const additionalData = {
        tags: {
            'ct-api-statusCode': status,
            'ct-api-baseUrl': url.split('?')[0]
        },
        extras: {
            params: data,
            'ct-api-url': url,
            'ct-api-statusText': statusText
        }
    }

    logSentryError(error, CT_SENTRY_ERROR_TYPES.API_ERROR, additionalData)
}

export function invalidSession(e){
    if(e?.response?.status === 401 && e?.response?.data?.message === 'INVALID_SESSION'){
      window?.location?.reload()
     }
}